<div class="c-product row">
    <div class="col-9 p-0">
        <div class="titulo-producto">
            {{product.title}}

            <ng-container *ngIf="esProductoEnVenta; else equipoEnArriendo">
                <div class="c-contenedor-tipoV">
               <div class="c-text-sub-a"> Equipo en Venta</div>
                </div>
            </ng-container>
            <ng-template #equipoEnArriendo>
                <div class="c-contenedor-tipoA">
              <div class="c-text-sub"> Equipo en Arriendo</div> 
            </div>
            </ng-template>

        </div>
    </div>
    <div class="col-3 p-0 align-self-end" (click)="toggle()">
        <img *ngIf="!isClicked" class="icn-arrow-down c-mover-derecha" src="./assets/icons/icon-arrow-down.svg">
        <img *ngIf="isClicked" class="icn-arrow-down c-mover-derecha" src="assets/icons/icon-arrow-up.svg">
    </div>

    <ng-container *ngIf="product.isOpen">
        <div class="col-12 c-product-detail">
            <div class="row mt-15">
                <div class="col-6 p-0">
                    <div class="c-texto__carro--producto">Tipo de venta</div>
                </div>
                <div class="col-6  p-0 c-texto__carro--valor"> {{product.tipoVenta | tipoVenta}} </div>
            </div>
            <div class="row">
                <div  class="col-6 p-0 c-texto__carro--producto mt-15">Equipos inalámbricos</div>
                <div class="col-6 p-0"><select name="cantidad" class="select" [(ngModel)]="product.cantidadI">
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select> </div>
            </div>
            <div class="row">
                <div  class="col-6 p-0 c-texto__carro--producto mt-15">Equipos fijos</div>
                <div class="col-6 p-0"><select name="cantidad" class="select" [(ngModel)]="product.cantidadF">
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select> </div>
            </div>

            <div class="row">
                <div class="col align-self-start">
                </div>
                <div class="col align-self-end jus-right">
                    <i class="icon-eliminar c-mover-derecha" (click)="deleteProduct()"></i>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="row">
        <ng-container *ngIf="esProductoEnVenta">
            <div class="col-6">
                A pagar:
            </div>
            <div class="col-6">
                {{ product.cantidadUf }} UF + IVA
                (${{ product.amount  }} aproximado)
            </div>
        </ng-container>
        <ng-template #equipoEnArriendo>
            <div class="col-6">
                Valor arriendo mensual:
            </div>
            <div class="col-6">
                {{ product.cantidadUf }} UF + IVA
                (${{ product.amount }} aproximado)
            </div>
        </ng-template>
        
    </div>
</div>